import { ScreenCloseModal } from "../../components/ScreenModal"
import { Str_AddFail, Str_AddSucc, Str_SelectFriend } from "../../language/string_res"
import { TopicUserListRender } from "../Chat/TopicUsers"
import * as ImSdk from "../../../imsdk/api";
import { useCallback, useEffect, useState } from "react";
import { User } from "../../../imsdk/db/t_user";
import { useIsFocused } from "@react-navigation/native";
import { MainNavProps } from "../navigation/main/MainParamList";
import { hideLoading, showLoading } from "../../components/Loading";
import { showToast } from "../../components/Toast";
import globalEventBus from "../../utils/EventBus";
import { isSystemAcc } from "../Chat/CListItem";
export const AddUserModal = ({ navigation, route }: MainNavProps<'AddUserModal'>) => {
    const label = route.params.label
    const users = route.params.users ?? []
    const [addUsers, setAddUser] = useState<User[]>([])
    const uid = ImSdk.getInstance().CurrentUid()
    const isFoucsed = useIsFocused()
    useEffect(() => {
        if (isFoucsed) {
            initUsers()
        }
    }, [isFoucsed])

    const initUsers = () => {
        const uids = (users?.map(item => item.uid)) ?? [];
        uids.push(uid)
        ImSdk.getInstance().GetContact({ isfriend: 1 }).then(r => {
            const contacts = r.users || [];
            const newusers = contacts.filter((v) => {
                return !uids.includes(v.uid) && v.status !== "deleted" && !isSystemAcc(v.uid)
            });
            setAddUser(newusers);
        })
    }
    //向标签添加成员
    const onSubmit = useCallback((uids: number[]) => {
        showLoading()
        ImSdk.getInstance().GetUserMuti(uids).then(r => {
            const u = r.users ?? []
            if (u.length > 0) {
                ImSdk.getInstance().AddLabel(label, u, 0).then((r) => {
                    hideLoading()
                    if (!r.error) {
                        showToast(Str_AddSucc)
                        globalEventBus.emit("AddLabelUser", { label: label, users: u })
                        navigation.goBack()
                    } else {
                        showToast(r.error || Str_AddFail)
                    }
                })
            }
        })

    }, [label])
    return (<TopicUserListRender
        users={addUsers}
        title={Str_SelectFriend}
        backIcon={require('../../assets/image/icon_close.png')}
        backIconStyle={{ width: 30, height: 30 }}
        onClose={() => { navigation.goBack() }}
        onSubmit={onSubmit}
        hasRadio={true} />
    )
}